<template>
  <div class="etf-wrapper">
    <FundBasic class="section-margin" />
    <!-- <FundResult class="section-margin" />
    <FundPosition class="section-margin" />
    <FundSize class="section-margin" />
    <MoreTitle title="分红拆分" class="rk-title--dividends" @click="goPage" /> -->
  </div>
</template>

<script>
import FundBasic from '@/components/f10/etf/FundBasic.vue'
import FundResult from '@/components/f10/etf/FundResult.vue'
import FundPosition from '@/components/f10/etf/FundPosition.vue'
import FundSize from '@/components/f10/etf/FundSize.vue'
export default {
  components: { FundBasic, FundResult, FundPosition, FundSize },
  methods: {
    goPage() {
      this.$router.push({
        path: '/etf/dividends',
        query: {
          symbol: this.$route.query.symbol
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.etf-wrapper {
  .rk-title--dividends {
    padding-left: var(--edge-padding);
    padding-right: var(--edge-padding);
    margin-bottom: var(--section-margin);
    background: var(--bg-color-2);
  }
}
</style>
